import { store } from "public@store/index";
import { newLeanCould, sendMessage } from "pc@root/external/newIM";
import { action } from "pc@action/index";
import voteDialog from "../component/vote";
import { getQueryString } from "public@tool/getQuery";
export const connectLeanCloud = () => {
  const { chatRoomId, chatRoomName } = store;
  let name = chatRoomName;
  const urlName = getQueryString("name");
  if (!!urlName && !/micromessenger/.test(navigator.userAgent.toLowerCase())) {
    name = decodeURIComponent(decodeURIComponent(urlName));
  }
  newLeanCould(chatRoomId, name);
};

// 房间接收新消息
export const newMessage = (msg: any) => {
  if (msg.attributes.cmd === "allowall") {
    store.allow = false;
    msg.text = "管理员禁止发言";
  } else if (msg.attributes.cmd === "forbidall") {
    store.allow = true;
    msg.text = "管理员开启发言";
  }

  if (msg.attributes && msg.attributes.vote) {
    if (new Date().getTime() - msg.timestamp <= 5000) {
      voteDialog.voteHint(
        {
          voteId: msg.attributes.vote.voteId,
          voteTitle: msg.attributes.vote.voteTitle
        },
        action.confirmVote
      );
    }
  }
  const nm = store.cloudMessage.concat();
  if (nm.length > 100) {
    nm.shift();
  }
  nm.push(msg);

  store.cloudMessage = nm;
  store.sendMsgState = false;
  DOMScrollTransform();
};

export const disposeMessage = (data: any) => {
  newMessage(data);
  store.messageValue = "";
};

export const historyMessage = (msg: any) => {
  store.cloudMessage = msg;
  DOMScrollTransform();
};

export const leanSendMsg = (messageValue: any) => {
  sendMessage(messageValue);
};

export const DOMScrollTransform = () => {
  const target = document.querySelector(`.live__lean--cloud`) as HTMLElement;
  if (!!target) {
    target.scrollTop = target.scrollHeight + target.scrollTop;
  }
};



// WEBPACK FOOTER //
// ./src/pc/handle/message.ts